import URI from "urijs";

import type { IntlShape } from "@mnemonic/intl";
import { defineMessages } from "@mnemonic/intl";

import { commonMessages } from "../../../commonMessages";

export type TOperation = "apikey.create" | "apikey.renew" | "password.change" | "totp.initialize" | string;

const messages = defineMessages({
  createApikey: { id: "apikey.create", defaultMessage: "Create apikey" },
  renewApikey: { id: "apikey.renew", defaultMessage: "Renew apikey" },
  enrollPublicKey: { id: "publickey.enroll", defaultMessage: "Enroll public key" },
  totpInitialize: { id: "totp.initialize", defaultMessage: "Initialize TOTP" },
  unknownOperation: { id: "unknown.operation", defaultMessage: "Unknown operation" },
});

const operationToMessage = (operation: TOperation) => {
  switch (operation) {
    case "apikey.create":
      return messages.createApikey;
    case "apikey.renew":
      return messages.renewApikey;
    case "password.change":
      return commonMessages.ChangePassword;
    case "publickey.enroll":
      return messages.enrollPublicKey;
    case "totp.initialize":
      return messages.totpInitialize;
    default:
      return messages.unknownOperation;
  }
};
export const getOperationTitle = (operation: TOperation, intl: IntlShape) => {
  return operationToMessage(operation).id === "unknown.operation"
    ? `${intl.formatMessage(operationToMessage(operation))}: ${operation}`
    : intl.formatMessage(operationToMessage(operation));
};

interface IUserAuthSearchParams {
  operation: TOperation;
  context?: string | Array<string>;
  next?: string;
}

export const getUserAuthSearch = (href: string) =>
  URI.parseQuery(new URI(href).search()) as unknown as IUserAuthSearchParams;
